import { html } from "lit";
var icon_share_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M3 16a5.417 5.417 0 019.638-3.395l5.55-3.7a5.416 5.416 0 11.669 2.159l-5.221 3.482a5.437 5.437 0 01.013 2.86l5.672 2.834a5.416 5.416 0 11-.97 1.938l-5.672-2.835A5.417 5.417 0 013 16zm17.333 7.583a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0zm0-15.166c0 .343.054.675.153.986l.266.397-.083.056a3.25 3.25 0 10-.336-1.44zM5.167 16a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_share_default as default
};
//# sourceMappingURL=icon-share.js.map
